export Checkbox from './Checkbox';
export CheckboxGroup from './CheckboxGroup';

export { default } from './Checkbox'; // Backward compatibility



// WEBPACK FOOTER //
// ./src/index.js